module.exports = __webpack_public_path__ + "static/media/Diana Cook Headshot.e026921f.jpeg";